/**
 * Authentication Error wrapper exception.
 */
export default class AuthError extends Error {
  /**
   * Constructor function
   *
   * @param {object} error
   * @param {string} [error.message]
   * @param {number} [error.statusCode] HTTP status code
   * @param {string} [error.statusText] HTTP status message
   * @param {string} [error.code] Node Error Code (eg, E_SOMETHING)
   * @param {string} [error.error]
   * @param {string} [error.description]
   * @param {string} [error.name]
   * @param {any} [error.errorDetails]
   * @param {string} [error.errorDescription]
   * @param {any} [error.policy]
   * @param {Error} [error.original] Source error
   */
  constructor(error) {
    const {
      original: sourceError,
      statusCode,
      statusText,
      code,
      error: errorCode,
      description,
      errorDetails,
      errorDescription,
      name,
      policy,
      message
    } = error;

    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message || sourceError?.message || name || code || errorCode || 'unknown');

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(error instanceof Error ? error : sourceError || this, AuthError);
    }
    this.name = 'AuthError';
    this.code = code;
    this.description = description;
    this.sourceError = sourceError;
    this.errorDetails = errorDetails;
    this.errorDescription = errorDescription;
    this.policy = policy;
    this.statusCode = statusCode;
    this.statusText = statusText;
  }
}